const initState = {
    fetching: false,
    fetched: false,
    error: null,
    payload: {},
    saved: false,
    message: null,
    isDeleted: false,
};

const dnReportReducer = (state = initState, action) => {
    switch (action.type) {
        case 'DNREPORT_PENDING':
            return {
                ...state,
                fetching: true
            };
        case 'DNREPORT_REJECTED':

            if (action.payload.response.status === 401) {
                localStorage.removeItem('token');
            }

            return {
                ...state,
                error: action.payload.response,
                fetching: false
            };
        case 'DNREPORT_FULFILLED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                payload: action.payload.data,
                error: null,
                saved: false,
                isDeleted: false
            };
        default:
            return state;
    }
};

export default dnReportReducer;
